export default __webpack_public_path__ + "static/media/paid-deposit.c1f380e1.svg";